import { Label } from "reactstrap";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import PriceInput from "../PriceInput";
import { ReactComponent as IconMatic } from "@assets/ic-matic.svg";
import {
  convertMaticToUsd,
  convertUsdToMatic,
  moneyPipe,
  toDollar,
} from "@helpers/price";
import { maticId } from "@const/subscriptionManagement";
import { MAX_USD_PRICE, USD_DECIMAL_PART } from "@validation/lengthConstants";
import classNames from "classnames";

import styles from "./index.module.scss";

const AmountInput = ({
  hideError,
  onBlur,
  itemPriceType,
  isMatic,
  usdPrice,
  itemPrice = "0",
  handleMinMaticAmount,
  minMaticAmount,
  name = "amount",
  maxAmount = MAX_USD_PRICE,
  withoutTouch,
}) => {
  const { t } = useTranslation("labels");

  const { setFieldValue } = useFormikContext();
  const isMaticItem = itemPriceType === Number(maticId);
  const itemPriceToDollar = toDollar(itemPrice);

  const minPriceInUsd = isMaticItem
    ? convertMaticToUsd(itemPrice, usdPrice)
    : itemPriceToDollar;

  const maxPrice = isMatic ? convertUsdToMatic(maxAmount, usdPrice) : maxAmount;

  const handleMinAmount = (value = 0) => {
    if (!usdPrice) {
      return value;
    }

    const minPriceInMatic =
      minMaticAmount ||
      (isMaticItem ? itemPrice : convertUsdToMatic(minPriceInUsd, usdPrice));

    if (isMatic && handleMinMaticAmount && value < minPriceInMatic) {
      return minPriceInMatic;
    }

    if (!isMatic && value < minPriceInUsd) {
      return minPriceInUsd;
    }

    return value;
  };

  const formatter = moneyPipe(USD_DECIMAL_PART);

  const handleBlur = ({ target = 0 }) => {
    const value = parseFloat(target.value || "0");

    const minValue = handleMinAmount(value);

    if (value != minValue) {
      setFieldValue(name, formatter(minValue), true);
      return;
    }

    setFieldValue(name, formatter(Math.min(value, maxPrice)), true);
  };

  return (
    <>
      <Label for={name} className={classNames("text-body-2", styles.label)}>
        {t("AMOUNT")}
      </Label>
      {/* todo: update */}
      <div className="d-flex w-100">
        <div className="position-absolute pt-1" style={{ zIndex: 1 }}>
          {isMatic ? <IconMatic /> : ""}
        </div>
        <PriceInput
          hideCurrency
          isMatic={isMatic}
          priceName={name}
          hideError={hideError}
          wrapperClassName="w-100"
          onBlur={onBlur ?? handleBlur}
          inputClassName={!isMatic ? "ps-3" : "ps-4"}
          withoutTouch={withoutTouch}
        />
      </div>
    </>
  );
};

export default AmountInput;
